import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestMethod, ResponseContentType } from "@angular/http";

import { City, State, Vendedor } from "@shared/models";
import { Holiday } from "@shared/models/holiday.interface";
import { Visit } from "../models/visit.interface";

import { ConfigService } from "@shared/utils/config.service";

import { BaseService } from "@core/services/base.service";

import { Observable } from "rxjs/Rx";

//import * as _ from 'lodash';

// Add the RxJS Observable operators we need in this app.
import "../../../rxjs-operators";
import { ExportarVendedoresSemAgendamentoParameters, GetVendedoresPorEstadoParameters, GetVendedoresSemAgendamentoParameters,GetVendedoresComAgendamentoParameters, RetornoGetVendedoresSemAgendamento } from './models';

@Injectable()
export class VisitasService extends BaseService {
  baseUrl: string = "";

  constructor(private http: Http, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  authorizedHeaders():Headers {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return headers;
  }

  getStates(idSetor): Observable<State[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/locations/states?setor=${idSetor}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCities(idState: number, idSetor): Observable<City[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/locations/cities?state=${idState}&setor=${idSetor}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getDistricts(idCity: number, idSetor): Observable<string[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/locations/districts?city=${idCity}&setor=${idSetor}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVisitsByAgent(idAgent: number): Observable<Visit[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/visits/getByAgent?agentId=" + idAgent, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVisitsByParams(
    agentId: any = 0,
    ufId: any = 0,
    cityId: any = 0,
    district: any = "",
    lastMov: number = 0
  ): Observable<Visit[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    let params = "";

    if (agentId != 0)
      params += (params.length == 0 ? "agentId" : "&agentId") + "=" + agentId;

    if (ufId != 0 && ufId != undefined && ufId != "undefined")
      params += (params.length == 0 ? "ufId" : "&ufId") + "=" + ufId;

    if (cityId != 0 && cityId != undefined && cityId != "undefined")
      params += (params.length == 0 ? "cityId" : "&cityId") + "=" + cityId;

    if (district != "" && district != undefined && district != "undefined")
      params +=
        (params.length == 0 ? "district" : "&district") + "=" + district;

    if (lastMov != 0)
      params += (params.length == 0 ? "lastMov" : "&lastMov") + "=" + lastMov;

    console.log(params);

    return this.http
      .get(this.baseUrl + "/visits/GetByParam?" + params, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVisitsByParamsNewFilter(
    agentId: any = 0,
    ufId: any = 0,
    cityId: any = 0,
    district: any = "",
    lastMov: number = 0,
    typeConsult: number = 0
  ): Observable<Visit[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    let params = "";

    if (agentId != 0)
      params += (params.length == 0 ? "agentId" : "&agentId") + "=" + agentId;

    if (ufId != 0 && ufId != undefined && ufId != "undefined")
      params += (params.length == 0 ? "ufId" : "&ufId") + "=" + ufId;

    if (cityId != 0 && cityId != undefined && cityId != "undefined")
      params += (params.length == 0 ? "cityId" : "&cityId") + "=" + cityId;

    if (district != "" && district != undefined && district != "undefined")
      params +=
        (params.length == 0 ? "district" : "&district") + "=" + district;

    if (lastMov != 0)
      params += (params.length == 0 ? "lastMov" : "&lastMov") + "=" + lastMov;

    if (typeConsult != 0)
      params += (params.length == 0 ? "typeConsult" : "&typeConsult") + "=" + typeConsult;

    console.log(params);

    return this.http
      .get(this.baseUrl + "/visits/getVisitsByParamsNewFilter?" + params, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVendedores(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/vendedores/listarTodos", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVendedoresPorSetor(id): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/vendedores/listarPorSetor?setorId=${id}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVendedoresPorEstado(
    params: GetVendedoresPorEstadoParameters
  ): Observable<Vendedor[]> {
    return this.http
    .post(`${this.baseUrl}/vendedores/listarporestado`, params)
    .map(response => response.json())
    .catch(this.handleError);
  }

  getVendedoresPorSetores(params): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(`${this.baseUrl}/vendedores/listarPorSetores`, params, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getSetores(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/setor/listarTodos", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getInvasionExpired(): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/visits/getInvasionExpired", { headers })
      .map(response => response.json())
      .catch(this.handleError);

  }

  getStatusVisita(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/statusVisita/listarTodos", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVisitaById(id): Observable<string[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/visits/getById?id=" + id, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  filterVisitasPorHistorico(params): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/listarHistorico", params, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVisita(IdCli, idSetor, idFiliall, dataPrevVisita): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${
          this.baseUrl
        }/visits/GetVisita?IdCli=${IdCli}&idSetor=${idSetor}&idFilial=${idFiliall}&dataPrevVisita=${dataPrevVisita}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getListaVisitas(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/GetListaVisitas`, { headers, params })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getListaClientesProximos(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/GetListaClientesProximos`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getSemana(data) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/GetSemana?dataParam=${data}&proxima=true`, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getProximaSemana(): Observable<number[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/GetProximaSemana`, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getClienteCnpj(Cnpj): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/clients/buscaCliente?Cnpj=${Cnpj}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  editVisita(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/alterar", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  salvarVisitaSemPlanejamento(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/incluir", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  getAlertasByCliente(idCliente, data) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/alertas/listarPorVisita?idCliente=${idCliente}&dataVisita=${data}`, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  salvarAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/alertas/incluir", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  excluirAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/alertas/excluir", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  consultarControleDeVisitas(params): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/listarControleVisita", params, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  consultarControleDeVisitasTodos(params): Observable<{
    visitas: Visit[],
    totalFormasVisita: {id: number, nome: string, status: string, total: number}[];
  }> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/listarControleVisitaTodos", params, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  listMenos8ClientesAtivos(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/listMenos8ClientesAtivos", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  LiebrarMenos8ClientesAtivos(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/LiebrarMenos8ClientesAtivos", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

  saveFeriados(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/saveFeriados", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

  listFeriadosMunicipaisEstaduais(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/listFeriadosMunicipaisEstaduais", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  listHistoricoReagendamento(params): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/listHistoricoReagendamento", params,  { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  saveVisita(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/incluirLista", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

  IncluirVisitaSemApagarAnterior(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/IncluirVisitaSemApagarAnterior", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

  saveVisitaReagendamento(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/incluirListaReagendamento", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

  getHolidays(weekStartDate, weekEndDate): Observable<Holiday[]> {
    return Observable.of([]);  //TODO implementar esta chamada quando houver um endpoint
  }

  getScheduledVisits(agentId, weekStartDate, weekEndDate): Observable<any[]> {

    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(`${this.baseUrl}/visits/GetListaDiasdaSemana?agentId=${agentId}&dataInicial=${weekStartDate}&dataFinal=${weekEndDate}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getClienteById(id, trazerAlertas=true): Observable<string[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/clients/getInfo?idCliente=${id}&trazerAlertas=${trazerAlertas}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  transferirPlanejamento(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    return this.http
      .post(this.baseUrl + "/visits/transmitirPlanejamento", params, { headers });
  }

  getFeriados(weekStartDate, weekEndDate): Observable<any[]> {

    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(`${this.baseUrl}/visits/getFeriado?dataInicio=${weekStartDate}&dataFim=${weekEndDate}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getFeriadosSAC(weekStartDate, weekEndDate): Observable<any[]> {

    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(`${this.baseUrl}/visits/getFeriadoSAC?dataInicio=${weekStartDate}&dataFim=${weekEndDate}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  imprimirPlanejamento(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    let requestOptions = {
      method: RequestMethod.Post,
      responseType: ResponseContentType.Blob,
      headers: headers
    }

    return this.http
      .post(this.baseUrl + "/visits/imprimirPlanejamentoDinkToPDF", params, requestOptions);
  }

  getFormasVisitasAtivas(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/FormaVisita/getAllAtivos`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVendedoresSemAgendamento(params: GetVendedoresSemAgendamentoParameters): Observable<RetornoGetVendedoresSemAgendamento[]> {
    const headers = this.authorizedHeaders()

    return this.http
      .post(`${this.baseUrl}/vendedores/buscarVendedoresSemAgendamento`, params,  { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVendedoresComAgendamento(params: GetVendedoresComAgendamentoParameters): Observable<RetornoGetVendedoresSemAgendamento[]> {
    const headers = this.authorizedHeaders()

    return this.http
      .post(`${this.baseUrl}/vendedores/buscarVendedoresComAgendamento`, params,  { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  AlterarTransmissaoRepresentante(params: GetVendedoresComAgendamentoParameters): Observable<RetornoGetVendedoresSemAgendamento[]> {
    const headers = this.authorizedHeaders()

    return this.http
      .post(`${this.baseUrl}/vendedores/AlterarTransmissaoRepresentante`, params,  { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  exportarVendedoresSemAgendamento(params: ExportarVendedoresSemAgendamentoParameters): Observable<any> {
    const headers = this.authorizedHeaders()

    const requestOptions = {
      method: RequestMethod.Get,
      responseType: ResponseContentType.Blob,
      headers: headers,
    }

    return this.http
      .post(`${this.baseUrl}/vendedores/exportarExcel`, params, requestOptions)
      .catch(this.handleError);
  }

  saveStatusVisitaProvisoriaCliente(params){
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/saveStatusVisitaProvisoriaCliente", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

  deleteVisita(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/DeleteVisita", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

  CheckPossibilityOfTransmit(agentId, weekStartDate, weekEndDate): Observable<any[]> {

    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(`${this.baseUrl}/visits/CheckPossibilityOfTransmit?agentId=${agentId}&dataInicial=${weekStartDate}&dataFinal=${weekEndDate}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  saveStatusSemAgendamento(params): Observable<any> {
    // salvarAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/visits/saveStatusSemAgendamento?cnpj=${params.cnpj}&dataSelecionada=${params.dataSelecionada}&status=${params.status}&cdfzs=${params.cdfzs}&setor=${params.setor}&idVnd=${params.idVnd}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);

  }

  getListStatusSemVisita(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + `/visits/getListStatusSemVisita?setor=${params.setor}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  deleteLibMenos8ClientesAtivos(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/deleteLibMenos8ClientesAtivos", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

  deleteFeriado(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/deleteFeriado", params, { headers })
      .map(response => '')
      .catch(this.handleError);
  }

}
